import { defineMessages } from 'react-intl';

export default defineMessages({
  matomoVisits: 'Visits',
  matomoActions: 'Actions',
  matomoConversions: 'Conversions',
  questionResponses: 'Survey responses',
  ga4Events: 'GA4 events',

  filterCategoryVisitSession: 'Visit & session',
  filterCategoryVisitor: 'Visitor',
  filterCategoryDevice: 'Device',
  filterCategoryBrowser: 'Browser',
  filterCategoryReferrer: 'Referrer',
  filterCategoryCampaign: 'Campaign',
  filterCategoryPageview: 'Pageview',
  filterCategoryEvent: 'Events',
  filterCategoryPerformance: 'Performance',
  filterCategoryConversion: 'Conversions',
  filterCategorySurvey: 'Survey responses',

  visitLastActionTime: 'Visit last action time',
  visitActions: 'Visit action count',
  visitEvents: 'Visit event count',
  visitInteractions: 'Visit interaction count',
  visitSearches: 'Visit search count',
  visitTotalTime: 'Visit total time',
  visitTotalActions: 'Visit total actions',
  visitEntryUrl: 'Visit entry URL',
  visitEntryTitle: 'Visit entry title',
  visitExitUrl: 'Visit exit URL',
  visitExitTitle: 'Visit exit title',
  visitGoalConverted: 'Visit converted a goal',
  visitGoalConvertedFalse: 'Visit did not convert a goal',
  visitorReturning: 'Visitor is returning',
  visitorVisitCount: 'Visitor visit count',
  visitorSecondsSinceFirstVisit: 'Visitor seconds since first visit',
  visitorSecondsSinceLastVisit: 'Visitor seconds since last visit',
  visitorCountry: 'Visitor country',
  visitorCity: 'Visitor city',
  visitorLocalTime: 'Visitor local time',
  deviceType: 'Device type',
  deviceBrand: 'Device brand',
  deviceOs: 'Device OS',
  deviceOsVersion: 'Device OS version',
  deviceModel: 'Device model',
  deviceResolution: 'Device resolution',
  browserName: 'Browser name',
  browserVersion: 'Browser version',
  browserLocale: 'Browser locale',
  browserCookies: 'Browser cookies enabled',
  browserCookiesFalse: 'Browser cookies disabled',
  browserEngine: 'Browser engine',
  referrerType: 'Referrer type',
  referrerKeyword: 'Referrer keyword',
  referrerUrl: 'Referrer URL',
  referrerName: 'Referrer name',
  campaignContent: 'Campaign content',
  campaignGroup: 'Campaign group',
  campaignKeyword: 'Campaign keyword',
  campaignMedium: 'Campaign medium',
  campaignName: 'Campaign name',
  campaignSource: 'Campaign source',
  campaignId: 'Campaign ID',
  campaignPlacement: 'Campaign placement',

  actionUrl: 'Action URL',
  actionUrlType: 'Action URL type',
  actionUrlPath: 'Action URL path',
  actionName: 'Action name',
  actionNameType: 'Action name type',
  pageviewUrl: 'Pageview URL',
  pageviewPath: 'Pageview URLpath',
  pagePathSegment: 'Page path segment',
  pageviewTitle: 'Pageview title',
  pageviewPosition: 'Pageview position',
  siteSearchCategory: 'Site search category',
  siteSearchResults: 'Site search results',
  actionRefUrl: 'Previous action URL',
  actionRefUrlType: 'Previous action URL type',
  actionRefTitle: 'Previous action title',
  actionRefTitleType: 'Previous action title type',
  eventCategory: 'Event category',
  eventCategoryType: 'Event category type',
  eventAction: 'Event action',
  eventActionType: 'Event action type',
  eventName: 'Event name',
  eventNameType: 'Event name type',
  eventUrl: 'Event URL',
  eventUrlPath: 'Event URL path',
  timeSpent: 'Time spent on action',
  timeSpentRefAction: 'Time spent on previous action',
  timeDomCompletion: 'Time DOM completion',
  timeDomProcessing: 'Time DOM processing',
  timeNetwork: 'Time network',
  timeOnLoad: 'Time on load',
  timeServer: 'Time server',
  timeTransfer: 'Time transfer',

  conversionGoalId: 'Goal',

  surveyRespondent: 'Responded to a survey',
  surveyRespondentFalse: 'Did not respond to a survey',
  surveyResponseClientPanel: 'Participated in client panel',
  surveyResponseClientPanelFalse: 'Did not participate in client panel',
  surveyGroupId: 'Survey',
  surveyResponseTime: 'Survey response time',
  surveyResponsePageUrl: 'Survey response page URL',
  surveyResponsePageTitle: 'Survey response page title',
  surveyRespondentDeviceType: 'Survey respondent device type',
  surveyRespondentCountry: 'Survey respondent country',
  surveyRespondentBrowserLanguage: 'Survey respondent browser language',
  questionResponseQuestionId: 'Survey question',
  questionResponseQuestionType: 'Survey question type',
  questionResponseOptionId: 'Question options',
  questionResponseText: 'Question response text',
  regexSyntaxLabel: 'Regular expression syntax',
});
